<template>
    <div class="row teaser-section None">

        <div v-if="component.showLoading" class="loading-icon columns text-center prepend-top noprint">
            <p>
                <img src="/Assets/Campus/Common/img/Icons/loading-blue-50x50.gif" alt="loading..." />
            </p>
        </div>

        <div v-if="component.result" class="teasercontent large-16 columns filter-main">

            <div class="list-header row prepend-top">
                <div class="tablet-column">
                    <label class="medium-3 large-3 widget-title columns hide-for-small">
                        {{ getTranslation('camp_raum_SearchResultDateTime') }}
                    </label>
                    <label class="widget-title medium-11 large-11 columns hide-for-small">
                        {{ getTranslation('camp_raum_SearchResultResourcePlace') }}
                    </label>
                    <label class="medium-5 large-5 widget-title columns large-offset-1 hide-for-small">
                        {{ getTranslation('camp_raum_Action') }}
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="filter-list-holder">
                    <ul id="fl" class="nav large filter-list columns ul">

                        <li v-if="component.result.entries.length === 0" class="list-item noresults row">
                            <header class="tablet-column columns text-center no-outline">
                                <p>{{ getTranslation('camp_NoDataFound') }}</p>
                            </header>
                        </li>

                        <ResultEntry v-for="entry in component.result.entries"
                                     :key="entry.bookingKey"
                                     :entry="entry"
                                     :translations="model.translations" />

                    </ul>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
    import RaumResMyBookings from "../../../_Api/RaumResMyBookings";
    import ResultEntry from "./components/ResultEntry.vue"

    export default {
        components: {
            ResultEntry
        },
        data() {
            return {
                "model": {
                    "translations": null
                },
                "component": {
                    "showLoading": true,
                    "result": null
                }
            }
        },
        created() {
            let data = this.$parent.$data;
            this.model = data.model;
            this.load();
        },
        methods: {
            load() {
                var query = null;
                RaumResMyBookings.load(query, this.loadSuccess, this.loadFailure, this.loadAlways);
            },
            getTranslation(key) {
                return this.model.translations[key];
            },
            loadSuccess(data) {
                if (data.successful) {
                    this.component.result = data;
                }
                else {
                    dialogError(data.message);
                }
            },
            loadFailure(status) {
                dialogError("Es ist ein Fehler aufgetreten: Status-Code " + status);
            },
            loadAlways() {
                this.component.showLoading = false;
            }
        }
    }
</script>
<style scoped>
</style>